export default "__VITE_ASSET__BxTM$hhi__"